
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { SectionStyle } from '@/utils/pdf-templates/types';

const sectionNames: { [key: string]: string } = {
    client: 'معلومات العميل',
    hotels: 'الفنادق',
    flights: 'الطيران',
    tours: 'الجولات',
    price: 'السعر',
    notes: 'ملاحظات',
    terms: 'الشروط والأحكام',
    itinerary: 'جدول الرحلة',
    contact: 'معلومات التواصل',
    offers: 'عروض خاصة',
    citiesPlan: 'خطة المدن',
    services: 'خدمات إضافية',
    inclusions: 'ما يشمله العرض',
    exclusions: 'ما لا يشمله العرض',
    transport: 'النقل والمواصلات',
};

const defaultIcons: { [key: string]: string } = {
    client: '👤', hotels: '🏨', flights: '✈️', tours: '🎯',
    price: '💰', notes: '📝', terms: '📋', itinerary: '🗓️',
    contact: '📞', offers: '🎁', citiesPlan: '🗺️', services: '⚙️',
    inclusions: '✅', exclusions: '❌', transport: '🚗',
};

interface Props {
    sectionStyles: { [sectionId: string]: SectionStyle };
    onChange: (styles: { [sectionId: string]: SectionStyle }) => void;
}

export function SectionStyleSettings({ sectionStyles, onChange }: Props) {
    const updateSection = (sectionId: string, key: keyof SectionStyle, value: string) => {
        onChange({
            ...sectionStyles,
            [sectionId]: {
                ...(sectionStyles[sectionId] || getDefault(sectionId)),
                [key]: value,
            },
        });
    };

    const getDefault = (id: string): SectionStyle => ({
        backgroundColor: '',
        borderColor: '',
        titleColor: '',
        icon: defaultIcons[id] || '📄',
    });

    const getStyle = (id: string) => sectionStyles[id] || getDefault(id);

    return (
        <Accordion type="multiple" className="w-full">
            {Object.keys(sectionNames).map((id) => {
                const style = getStyle(id);
                return (
                    <AccordionItem key={id} value={id}>
                        <AccordionTrigger className="text-sm py-2">
                            <span className="flex items-center gap-2">
                                <span>{style.icon || defaultIcons[id]}</span>
                                {sectionNames[id]}
                            </span>
                        </AccordionTrigger>
                        <AccordionContent>
                            <div className="space-y-3 p-2">
                                <div className="flex items-center justify-between">
                                    <Label>لون الخلفية</Label>
                                    <div className="flex items-center gap-2">
                                        <Input type="color" value={style.backgroundColor || '#1a1a2e'} onChange={(e) => updateSection(id, 'backgroundColor', e.target.value)} className="p-1 h-8 w-8 cursor-pointer" />
                                        <span className="text-xs text-muted-foreground font-mono w-16">{style.backgroundColor || 'تلقائي'}</span>
                                    </div>
                                </div>
                                <div className="flex items-center justify-between">
                                    <Label>لون الحدود</Label>
                                    <div className="flex items-center gap-2">
                                        <Input type="color" value={style.borderColor || '#d4a853'} onChange={(e) => updateSection(id, 'borderColor', e.target.value)} className="p-1 h-8 w-8 cursor-pointer" />
                                        <span className="text-xs text-muted-foreground font-mono w-16">{style.borderColor || 'تلقائي'}</span>
                                    </div>
                                </div>
                                <div className="flex items-center justify-between">
                                    <Label>لون العنوان</Label>
                                    <div className="flex items-center gap-2">
                                        <Input type="color" value={style.titleColor || '#d4a853'} onChange={(e) => updateSection(id, 'titleColor', e.target.value)} className="p-1 h-8 w-8 cursor-pointer" />
                                        <span className="text-xs text-muted-foreground font-mono w-16">{style.titleColor || 'تلقائي'}</span>
                                    </div>
                                </div>
                                <div className="flex items-center justify-between">
                                    <Label>الأيقونة</Label>
                                    <Input value={style.icon || defaultIcons[id]} onChange={(e) => updateSection(id, 'icon', e.target.value)} className="w-20 text-center" maxLength={4} />
                                </div>
                            </div>
                        </AccordionContent>
                    </AccordionItem>
                );
            })}
        </Accordion>
    );
}
